export default {"src":"/_next/static/media/B2BNeedHelp.d629121b.svg","height":228,"width":404};